const CloudShader = {
  uniforms: {
    texture1: { value: null },
    texture2: { value: null },
    iTime: { value: 0 },

    cloudDensity: { value: 0.01 },
    cloudDensity2: { value: 1 },
    cloudalpha: { value: 1 },
    cloudscale: { value: 8.0 },
    speed: { value: 0.3 },
    color: { value: [0.9, 0.9, 0.9] },
    flash: { value: 0.0 },
    skyTime: { value: 7.0 },
  },
  vertexShader:
   `varying highp vec2 vUv;
    void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }`,
  fragmentShader:
  `
  uniform float iTime;
  uniform float cloudDensity;
  uniform float cloudDensity2;
  uniform float cloudalpha;
  uniform float cloudscale;
  uniform float speed;
  uniform float flash;
  uniform float skyTime;
  uniform vec3 color;
  uniform sampler2D texture1;
  uniform sampler2D texture2;
  uniform sampler2D BackTex1;
  
  varying highp vec2 vUv;
  
  vec3 colorfix(vec3 color) {
      return vec3(color.r * 0.1, color.g * 0.1, color.b * 0.1);//0.00392
  }

  float distanceTo(vec2 src, vec2 dst) {
      float dx = src.x - dst.x;
      float dy = src.y - dst.y;
      float dv = dx * dx + dy * dy;
      return sqrt(dv);
  }
  float Zsin(float x) {
      float y = abs(fract(x * 0.3) - 0.5) * 2.;
      return y;
  }

  vec4 morningColor = vec4(0.5, 0.7, 1.0, 0.2); // 清晨颜色
  vec4 dayColor = vec4(0.3, 0.6, 1.0, 1.0);     // 白天颜色
  vec4 eveningColor = vec4(0.8, 0.4, 0.6, 1.0); // 傍晚颜色
  vec4 nightColor = vec4(0.1, 0.1, 0.3, 0.2);   // 夜晚颜色

  vec4 getSkyColor(float time) {
      vec4 timeColor;
      if (time < 6.0) {
          timeColor = mix(nightColor, morningColor, time / 6.0);
      } else if (time < 12.0) {
        timeColor = mix(morningColor, dayColor, (time - 6.0) / 6.0);
      } else if (time < 18.0) {
        timeColor = mix(dayColor, eveningColor, (time - 12.0) / 6.0);
      } else {
        timeColor = mix(eveningColor, nightColor, (time - 18.0) / 6.0);
      }
    return timeColor;
}  
  void mainImage(out vec4 fragColor, in vec2 fragCoord) {
      vec2 uv = vUv;
      uv -= vec2(.5);
      vec2 uvR = mat2(cos(iTime * speed), -sin(iTime * speed), sin(iTime * speed), cos(iTime * speed)) * uv; 
      vec2 uvR_m = mat2(cos(iTime * 0.8 * speed), -sin(iTime * 0.8 * speed), sin(iTime * 0.8 * speed), cos(iTime * 0.8 * speed)) * uv;///旋转矩阵
      uvR *= (sin(iTime) * 0.01 + 1.);
      vec3 T1 = texture(texture1, uvR_m * cloudscale).rgb;
      vec3 T2 = texture(texture2, uvR * cloudscale * 0.2).rgb;
      vec3 T1base = vec3(pow(T1.x, cloudDensity) * 10.);
      vec3 T2noise = vec3(pow(T2.x, cloudDensity));
      vec3 T2noiseS = vec3(pow(T2.x, 5.)) * vec3(0.1, 0.5, 0.8) * clamp((Zsin(iTime * 5.) * 100. - 99.), 0., 1.) * flash; 
      float sphere = pow(distanceTo(vec2(0.5, 0.5), vUv), 9.) * 5000.;
      fragColor = vec4(T1base * T2noise * colorfix(color) + T2noiseS, pow(T1.x, cloudalpha) * cloudDensity2 * pow(T2.x, cloudalpha)*(1.-sphere)*(getSkyColor(skyTime).a));
  }
  
  void main() {
     vec2 fragCoord = gl_FragCoord.xy;
     mainImage(gl_FragColor, fragCoord);
  }`,
}

export default CloudShader